import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';

interface TableCellProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export function TableCell({
  children,
  className,
  align = 'left',
}: TableCellProps) {
  return (
    <div
      className={classNames(
        styles.tableCell,
        {
          [styles.alignCenter]: align === 'center',
          [styles.alignRight]: align === 'right',
        },
        className
      )}
    >
      {children}
    </div>
  );
}

export default TableCell;
